import TimelineItem from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Mission/TimelineItem"
import type { MicroSite } from "@/lib/api";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const MissionTimeline = ({data}:{data: MicroSite}) => {
      if(!data){
    return null;
  };  

  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <VerticalTimeline layout={"1-column-left"} lineColor="#D9D9D9" className="w-full !p-0">
      {Array.isArray(data?.missionTimeLineSection?.missionTimeLineSectionDetails) && data.missionTimeLineSection.missionTimeLineSectionDetails.map((item, index) => (
         <VerticalTimelineElement key={index} contentStyle={{ border: "transparent", borderRadius: '0px', padding: '0px', marginLeft: "7.5rem", boxShadow: "none" }}   iconClassName="bg-[#d9d9d9] border-[#d9d9d9] !shadow-none" >
        <TimelineItem key={index} data={item} brandingData={data?.branding} />
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>
    </div>
    
  )
}

export default MissionTimeline